import Link from '@material-ui/core/Link';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
const InternalLink = ({ to, ...rest }) => {
    const renderLink = React.useMemo(() => React.forwardRef(({ children, ...linkRest }, ref) => (React.createElement(RouterLink, { ...linkRest, ref: ref, to: to }, children))), [to]);
    return (React.createElement(Link, { ...rest, component: renderLink }, rest.children));
};
export default InternalLink;
